import { withNamespace } from "@/i18n/lazy-route"

/** Payments as staff see them (LLD §9.18, Task 6.2), with the `adminPayments` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminPayments.json"),
  fr: () => import("@/i18n/locales/fr/adminPayments.json"),
}

export const PaymentsScreen = withNamespace(
  "adminPayments",
  () => import("./screens/PaymentsScreen"),
  translations,
)
export const ReviewScreen = withNamespace(
  "adminPayments",
  () => import("./screens/ReviewScreen"),
  translations,
)
export const PaymentDetailScreen = withNamespace(
  "adminPayments",
  () => import("./screens/PaymentDetailScreen"),
  translations,
)
